import React from 'react';
import { Field } from 'formik';
import WizardStep from './wizard_step';
import HomeIcon from './home.png';
import SolarIcon from './solar.png';
import CAStateOutline from './california-state-outline.png';
import PowerProviderLogos from './logos-providers.png';

const SGIPWizardStep = () => (
  <WizardStep>
    <h2>Check all that apply.</h2>
    <div className="sgip-interests">
      <div className="sgip-interest-item">
        <label htmlFor="isHomeowner">
          <Field name="isHomeowner" id="isHomeowner" type="checkbox" />

          <div className="option">
            <div className="icon">
              <img src={HomeIcon} alt="Homeowner" />
            </div>
            <div className="title">I own my home</div>
          </div>
        </label>
      </div>
      <div className="sgip-interest-item">
        <label htmlFor="liveInCalifornia">
          <Field name="liveInCalifornia" id="liveInCalifornia" type="checkbox" />

          <div className="option">
            <div className="icon">
              <img src={CAStateOutline} alt="California" />
            </div>
            <div className="title">I live in California</div>
          </div>
        </label>
      </div>
      <div className="sgip-interest-item">
        <label htmlFor="existingSolar">
          <Field name="existingSolar" id="existingSolar" type="checkbox" />

          <div className="option">
            <div className="icon">
              <img src={SolarIcon} alt="Solar panels" />
            </div>
            <div className="title">I have solar panels</div>
          </div>
        </label>
      </div>
      <div className="sgip-interest-item">
        <label htmlFor="energyProviders">
          <Field name="energyProviders" id="energyProviders" type="checkbox" />

          <div className="option">
            <div className="icon">
              <img src={PowerProviderLogos} alt="CA Power Providers" />
            </div>
            <div className="title">I get power from one of these companies</div>
          </div>
        </label>
      </div>
    </div>
  </WizardStep>
);

export default SGIPWizardStep;
